<template>
    <div id="module-loader">
        <div class="spring">
            <span class="bubble bubble1"></span>
            <span class="bubble bubble2"></span>
            <span class="bubble bubble3"></span>
            <span class="bubble bubble4"></span>
            <span class="bubble bubble5"></span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Loading"
    }
</script>

<style scoped>
    #module-loader {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }

    .spring {
        width: 0;
        height: 0;
        position: absolute;
        top: 50%;
        left: 50%;
        overflow: visible;
    }

    .bubble {
        background: rgba(255, 255, 255, 0.5);
        width: 30px;
        height: 30px;
        position: absolute;
        display: block;
        left: 0;
        margin-left: -15px;
        bottom: 0;
        opacity: 0;
        border-radius: 50%;
        animation: bubbleUp 1s infinite ease-in-out;
        -webkit-animation: bubbleUp 1s infinite ease-in-out;
        -o-animation: bubbleUp 1s infinite ease-in-out;
        -moz-animation: bubbleUp 1s infinite ease-in-out;
    }

    .bubble1 {
        left: 0px;
        top: 0px;
        -webkit-animation-delay: 0ms;
        animation-delay: 0ms;
    }

    .bubble2 {
        width: 15px;
        height: 15px;
        left: 0px;
        -webkit-animation-delay: 300ms;
        animation-delay: 300ms;
    }

    .bubble3 {
        left: -10px;
        top: -10px;
        -webkit-animation-delay: 600ms;
        animation-delay: 600ms;
    }

    .bubble4 {
        width: 30px;
        height: 30px;
        left: 5px;
        -webkit-animation-delay: 900ms;
        animation-delay: 900ms;
        -webkit-animation-duration: 1.5s;
        animation-duration: 1.5s;
    }

    .bubble5 {
        width: 20px;
        height: 20px;
        left: 0px;
        top: 0px;
        -webkit-animation-delay: 1200ms;
        animation-delay: 1200ms;
        -webkit-animation-duration: 1.2s;
        animation-duration: 1.2s;
    }

    @keyframes bubbleUp {
        0% {
            top: 0px;
            -webkit-transform: scale(0.5);
            opacity: 0
        }
        20% {
            top: 0px;
            -webkit-transform: scale(.75);
            opacity: 1
        }
        90% {
            top: -20px;
            -webkit-transform: scale(1);
            opacity: 1
        }
        98% {
            top: -40px;
            -webkit-transform: scale(3);
            opacity: 0
        }
        100% {
            top: 0px;
            -webkit-transform: scale(1);
            opacity: 0
        }
    }
</style>
